export default __webpack_public_path__ + "static/HYPED_Favicon-cd6e05918e969d8731f05ae8817372d4.png";